import React, {useState,useEffect, useMemo}   from "react";

import SceneBuild from '../collections/sceneBuild'
import Materials from '../collections/materials'
import CustomizedRadios from './ViewMenuRadio'

import useProgressiveImage from '../utils/progressiveLoad'


const Mask = ({ mask, multiply, children, size }) => (
    
    <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: `${size}`,
        backgroundRepeat: 'round',
        backgroundPosition: 'center',

        WebkitMaskImage: `url(${mask})`,
        
        WebkitMaskSize: "100%",
        WebkitMaskMode: 'alpha',

        img: `url(${multiply})`, 
        mixBlendMode: 'multiply', 
        }}>
            {children}
    </div>
        
)
const Image = ({  children, size }) => (
    
    <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${children})`,
        backgroundSize: `${size}%`,
        backgroundRepeat: 'round',
        backgroundPosition: 'center',

        
        }}>
    </div>
        
)

const Imageblur = ({ children, size }) => (
    
    <div style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        transform: `translate(2%, 2%) rotate(30deg) scale(1.5)`, 
        filter: 'blur(.7px)',
        opacity: '0.5'
        }}>
            {children}
    </div>
        
)




const sceneBuildFunc = (matString, sch) => {
    const temp = SceneBuild.filter(v => v.view === matString).filter(v => v.scheme === sch).map(choice => choice.imageUrl.default)
    const temp2 = SceneBuild.filter(v => v.view === matString).filter(v => v.scheme === sch).map(choice => choice.imageUrl2.default)
    return [temp, temp2]
  }

  


const Landscape = (props) => {
    const [viewIndex, setViewIndex] = useState(2);
    const [matScene, setMatScene] = useState(false);
    const [mounted, setMounted] = useState(false);
    const [matSceneNum, setMatSceneNum] = useState(0);
    const {asyncLogParams} = props
    const updateSceneMat = () => {
        setMatScene(materialFuncSceneSub("Landscape", viewIndex))
    }

    useEffect(() => {
        setMatScene(materialFuncSceneSub("Landscape", viewIndex))
    }, [viewIndex])

    const materialFunc = () => {
        // debugger
        const temp = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].imageUrlTile.default)
        return temp
      }
      

    const materialNatureFunc = (index) => {
        // debugger
        const temp = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].imageUrlTileLand)
        return temp[3][index].default
    };

    const materialEntourageFunc = (index) => {
        const temp = Materials.filter(v => v.name === 'entourage')[0].imageUrlTileLand
        return temp[index].default
    };


    const materialFuncSceneSub = (matString, sch) => {
        try{
            const temp = Object.values(props.material).map(val => Materials.filter(v => v.name === val)[0].mechanical)
            return temp[0]
        }
        catch {
            return ""
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    useMemo(() => {
        if (props.matScene > matSceneNum) {
            // updateSceneMat()
            updateSceneMat()
            setMatSceneNum(props.matScene)
        }},
     [matSceneNum, materialFunc])

    useEffect(() => {
        
        if (mounted){
          asyncLogParams("Landscape scene", viewIndex)
        } else {
            setMounted(true)
        }
        
  }, [viewIndex])

    //  
    let materialCache
    useEffect(() => {
        materialCache = materialSel[4]
        console.log(materialCache)
    }, [])

    const placeholder = materialCache
        
        const materialSel = materialFunc()
        const materialNatureSel = materialNatureFunc(viewIndex)
        const materialEntourageSel = materialEntourageFunc(viewIndex)
        const [sceneBuild, sceneBuild2] = sceneBuildFunc("Landscape", viewIndex)
        const sizeSwatch = 25

        const materialSceneBuilAssem =  !matScene ? sceneBuild[0] : sceneBuild2[0]

        // const placeholder = '../static/Context/Tile/Marble_S.4dda8b2f.png'

        const loadedZ1 = useProgressiveImage(materialSel[0]) || placeholder
        const loadedZ2 = useProgressiveImage(materialSel[1]) || placeholder
        const loadedWood = useProgressiveImage(materialSel[2]) || placeholder
        const loadedTile = useProgressiveImage(materialSel[4]) || placeholder
        const loadedIndustry = useProgressiveImage(materialSel[5]) || placeholder



        return (
            <div 
            id="LandscapeLayout"
            style={{
                position: "relative",
                height: "100%",
                width: "100%",
                backgroundColor: '#f3f3f3',
            }}>
                
                
                <div id="LandLayoutChild">

                    <img src={materialSceneBuilAssem} width='100%' alt='base' style={{img: `url(${materialSceneBuilAssem})`, mixBlendMode: 'multiply', width: '100%', position: "absolute" }}/>

                    <img src={sceneBuild[1]} width='100%' alt='otherbase' style={{img: `url(${sceneBuild[1]})`, mixBlendMode: 'normal', width: '100%', position: "absolute" }}/>


                    {/* working on patterning */}
                    <Mask mask={sceneBuild[2]} multiply={sceneBuild[1]} size={'25%'}> 
                        <Image  size={sizeSwatch} > 
                            {loadedZ1}
                        </Image>
                        <Imageblur>
                            <Image  size={sizeSwatch} > 
                                    {loadedZ1}
                            </Image>
                        </Imageblur>
                     </Mask>

                    <Mask mask={sceneBuild[3]} multiply={sceneBuild[1]} size={'25%'}> 
                        <Image  size={sizeSwatch} > 
                                {loadedZ2}
                        </Image>
                        <Imageblur>
                            <Image  size={sizeSwatch} > 
                                    {loadedZ2}
                            </Image>
                        </Imageblur>
                     </Mask>

                    <Mask mask={sceneBuild[4]} multiply={sceneBuild[1]}>
                        <Image  size={sizeSwatch} > 
                                {loadedWood}
                        </Image>
                    </Mask>
                    
                    <Mask mask={sceneBuild[5]} multiply={sceneBuild[1]}>
                        <Image  size={sizeSwatch} > 
                         {loadedTile}
                        </Image>
                    </Mask>
                    <Mask mask={sceneBuild[6]} multiply={sceneBuild[1]}>
                        <Image  size={sizeSwatch} > 
                         {loadedIndustry}
                        </Image>
                        
                    </Mask>

                </div>
                    <img src={materialEntourageSel} alt='entourage' style={{
                    position: "absolute",
                    width: '100%',
                    filter: 'drop-shadow(-15px 0px 4px rgba(50, 50, 50, .4))',
                    }}/>

                    <img src={materialNatureSel} alt='plant' style={{
                    position: "absolute",
                    width: '100%',
                    
                    }}/>

                
                <div style={{height: '100%', width: '100%', 
                display: 'flex', 
                alignItems: 'flex-end', 
                marginLeft: '40%', 
                position: 'absolute', }}>
                <CustomizedRadios setViewIndex={setViewIndex} />
                </div>
            </div>
        )
    
}

export default Landscape;